<div class="theme-farmer">

  <pds-eagri-header appName="erma"></pds-eagri-header>

  <div id="main" class="wide">
    <div class="r">
      <div id="app-data">

        <router-outlet></router-outlet>
        <div class="version">Verze: {{version}}</div>
      </div> <!-- /#app-data -->

      <div id="app-aux" [innerHTML]="navigation">

      </div>
    </div> <!-- /.r -->
  </div> <!-- /#main -->

  <pds-eagri-footer appName="erma"></pds-eagri-footer>
</div> <!-- /#page -->
